import React, {PureComponent, Fragment, ReactNode} from 'react';

import s from './coverageChoice.scss';
type PropsType = {
    isSelected: boolean;
    onToggle: () => void;
    phone: string;
};

/**
 * Button-checkbox for toggling enhanced coverage
 */
export class CoverageChoice extends PureComponent<PropsType> {
    /**
     * Render coverage choice component
     * @returns {ReactNode} - rendered component
     */
    render(): ReactNode {
        const {isSelected, onToggle, phone} = this.props;
        return (
            <Fragment>
                <label className={s.button} title="Add Enhanced coverage">
                    <input
                        checked={isSelected}
                        className={s.buttonInput}
                        name="coverage"
                        onChange={onToggle}
                        type="checkbox"
                    />
                    <span
                        aria-label="value switching"
                        className={s.buttonLabel}
                        data-test-active={isSelected}
                    >
                        Enhanced coverage
                    </span>
                </label>
                <p className={s.notice}>
                    <b className={s.noticeQuestion}>Have more questions?</b> Call {phone}
                </p>
            </Fragment>
        );
    }
}
